import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightSvg } from '~/svg';
import { fetchMyCampaignRequests } from '~/services/campaign';
import StatusBadge from '~/components/CampaignRequestDetails/StatusBadge';

interface CampaignRequest {
    id: number;
    patient_name: string;
    medical_reason: string;
    state: string;
    status_name: string;
}

const MyCampaignRequests = () => {
    const [requests, setRequests] = useState<CampaignRequest[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadRequests = async () => {
            try {
                setLoading(true);
                const response = await fetchMyCampaignRequests(5);
                setRequests(response.results || []);
            } catch (error) {
                console.error('Error fetching my campaign requests:', error);
                setRequests([]);
            } finally {
                setLoading(false);
            }
        };

        loadRequests();
    }, []);

    return (
        <div className='h-full rounded-sm border border-stroke bg-white p-4 shadow-default dark:border-strokedark dark:bg-boxdark md:p-6 xl:p-7.5'>
            <div className='mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between'>
                <h2 className='text-xl font-semibold text-black dark:text-white'>
                    My Campaign Requests
                </h2>

                <Link
                    to='/campaign-requests'
                    className='flex items-center gap-2 text-primary'
                >
                    View All <ArrowRightSvg />
                </Link>
            </div>

            <div className='flex flex-col gap-2'>
                {loading ? (
                    <div className='py-4 text-center text-sm text-secondary'>
                        Loading...
                    </div>
                ) : requests.length === 0 ? (
                    <div className='py-4 text-center text-sm text-secondary'>
                        No campaign requests assigned to you
                    </div>
                ) : (
                    requests.map((request) => (
                        <Link
                            key={request.id}
                            to={`/campaign-requests/${request.id}`}
                            className='relative z-1 grid grid-cols-12 items-center py-2 transition-colors hover:bg-gray-50'
                        >
                            <div className='col-span-9'>
                                <p className='font-bold'>{request.patient_name}</p>
                                <p className='text-[14px]'>
                                    {request.medical_reason}
                                    {request.state && (
                                        <>
                                            {' '}
                                            <span className='text-secondary'>
                                                &bull; {request.state}
                                            </span>
                                        </>
                                    )}
                                </p>
                            </div>
                            <div className='col-span-3'>
                                <div className='flex justify-end'>
                                    <StatusBadge status={request.status_name} />
                                </div>
                            </div>
                        </Link>
                    ))
                )}
            </div>
        </div>
    );
};

export default MyCampaignRequests;
